import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SharedComponentsSysTextService } from '@core/services/shared-components-sys-text.service';
import { FormControl, FormGroup } from '@angular/forms';


@Component({
    selector: 'app-slide-toggle',
    templateUrl: './slide-toggle.component.html',
    styleUrls: ['./slide-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SlideToggleComponent implements OnInit {
  static readonly componentName = 'SlideToggleComponent';
  
  @Input() public control: FormControl;
  @Input() public group: FormGroup;
  @Input() public hint: string;
  @Input() public icon: string;
  @Input() public inputType: string = 'text';
  @Input() public isHintHighlighted: boolean = true;
  @Input() public isHintWarning: boolean = false;
  @Input() public label: string;
  @Input() public capitalizeLabel: boolean = true;
  @Input() public labelPosition: string = 'after';  // options are: 'before' or 'after'
  @Input() public checked: boolean = false;
  @Input() public set isDisabled(isDisabled: boolean) {
    isDisabled ? this.control.disable() : this.control.enable();
  }
  @Input() public tooltip: string;
  @Output() public change = new EventEmitter();
  public sysText: any;

  // #endregion Properties (12)

  // #region Constructors (1)

  constructor(private text: SharedComponentsSysTextService) {}

  // #endregion Constructors (1)

  // #region Public Methods (1)

  public ngOnInit(): void {
    this.sysText = this.text.sysText[this.text.templates.inputField];
  }
}
